'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ugcTagShape = _reactImmutableProptypes2.default.contains({
  id: _react.PropTypes.number.isRequired,
  metadataId: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string.isRequired,
  url: _react.PropTypes.string.isRequired,
  createdDate: _react.PropTypes.string.isRequired,
  description: _react.PropTypes.string,
  userId: _react.PropTypes.number.isRequired
});

exports.default = ugcTagShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/ugcVideoShape.js
// module id = 1392
// module chunks = 1